import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api"; // Shared axios instance
import { hideLoader, showLoader } from "./loaderSlice";

// Helper to convert boolean flags to name
const getMethodName = (method) => {
  if (method.card === true) return "Card";
  if (method.cash === true) return "Cash";
  if (method.upi === true) return "UPI";
  return "Unknown";
};
// GET all payment methods
export const getPaymentMethods = createAsyncThunk(
  "paymentMethod/getPaymentMethods",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(`/getall/clinic/payment/methods`);
      if (res.status === 200) {
        const mapped = res.data.data.map(method => ({
          ...method,
          methodName: getMethodName(method),
        }));
        thunkAPI.dispatch(hideLoader());
        return mapped;
      }
      thunkAPI.dispatch(hideLoader());
      return [];
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch payment methods");
    }
  }
);

// POST create method
export const createPaymentMethod = createAsyncThunk(
  "paymentMethod/createPaymentMethod",
  async ({ name, status }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const body = { name, status};
      // if (methodName === "Card") body.card = true;
      // if (methodName === "Cash") body.cash = true;
      // if (methodName === "UPI") body.upi = true;

      const res = await api({ contentType: true, auth: true }).post(`/create/clinic/payment/method`, body);
      if (res.status === 200) {
        const method = res.data.data;
        thunkAPI.dispatch(hideLoader());
        return {
          ...method,
          methodName: getMethodName(method)
        };
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to create payment method");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const updatePaymentMethod = createAsyncThunk(
  "paymentMethod/updatePaymentMethod",
  async ({ methodId, name, status }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const body = { name, status};
      // if (methodName === "Card") body.card = true;
      // if (methodName === "Cash") body.cash = true;
      // if (methodName === "UPI") body.upi = true;

      const res = await api({ contentType: true, auth: true }).put(`/update/clinic/payment/method/${methodId}`, body); // ✅ Correct URL
      if (res.status === 200) {
        const updated = res.data.data;
        thunkAPI.dispatch(hideLoader());
        return {
          ...updated,
          methodName: getMethodName(updated)
        };
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to update payment method");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  }
);


export const deletePaymentMethod = createAsyncThunk(
  "paymentMethod/deletePaymentMethod",
  async ({ methodId }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(`/delete/clinic/payment/method/${methodId}`); // ✅ Correct URL
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return methodId;
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to delete payment method");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  }
);

const paymentMethodSlice = createSlice({
  name: "paymentMethod",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentMethods.fulfilled, (state, action) => {
        state.list = action.payload ?? [];
        state.loading = false;
        state.error = null;
      })
      .addCase(createPaymentMethod.fulfilled, (state, action) => {
        state.list.push(action.payload);
        state.loading = false;
        state.error = null;
      })
      .addCase(updatePaymentMethod.fulfilled, (state, action) => {
        const updated = action.payload;
        const index = state.list.findIndex((m) => m.methodId === updated.methodId);
        if (index !== -1) {
          state.list[index] = updated;
        }
        state.loading = false;
        state.error = null;
      })
      .addCase(deletePaymentMethod.fulfilled, (state, action) => {
        const id = action.payload;
        state.list = state.list.filter((m) => m.methodId !== id);
        state.loading = false;
        state.error = null;
      })
      .addCase(getPaymentMethods.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPaymentMethod.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePaymentMethod.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePaymentMethod.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPaymentMethods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error fetching payment methods.";
      });
  },
});

export default paymentMethodSlice.reducer;

// // Export Thunks
// export {
//   getPaymentMethods,
//   createPaymentMethod,
//   updatePaymentMethod,
//   deletePaymentMethod
// };